import cx from 'classnames';
import { ElementType, forwardRef, HTMLAttributes } from 'react';
import css from './Pill.module.scss';

export interface IPillProps extends HTMLAttributes<HTMLSpanElement> {
  color:
    | 'black'
    | 'blue'
    | 'dark-green'
    | 'dark-yellow'
    | 'gray'
    | 'green'
    | 'orange'
    | 'pink'
    | 'purple'
    | 'red'
    | 'teal'
    | 'yellow';
  icon?: ElementType;
  isBorderless?: boolean;
  isCircular?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const Pill = forwardRef<HTMLSpanElement, IPillProps>(
  (
    {
      children,
      className,
      color,
      icon: Icon,
      isBorderless = false,
      isCircular = false,
      size = 'sm',
      ...rest
    },
    ref
  ) => {
    const iconSize = isCircular ? 12 : 11;
    return (
      <span
        ref={ref}
        className={cx(
          css.pill,
          css[color],
          css[size],
          { [css.borderless]: isBorderless },
          { [css.circular]: isCircular },
          { [css.textless]: !children },
          className
        )}
        {...rest}
      >
        {Icon && <Icon height={iconSize} width={iconSize} />}
        {children}
      </span>
    );
  }
);

Pill.displayName = 'Pill';
